<template>
<ItpModal
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="WComment"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      name="comment"
      v-if="loaded"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpFormGroup
        name="message"
      >
        <ItpFormTextarea
          name="message"
          v-model="editor.message"
          required
          autofocus
          rows="8"
          :placeholder="'Comment message'|gettext"
        >
        </ItpFormTextarea>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :form="forms.comment"
      :text="'Save'|gettext"
      type="submit"
      :spinning="actions.submit.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      :disabled="actions.submit.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpModal>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class WComment extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "modal",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
  })
  parentId!: string;

  @Watch('parentId')
  onParent_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("parentId")
  }

  @Prop({
    required: true,
    type: Object,
  })
  parent!: object;

  @Watch('parent')
  onParent(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("parent")
  }

  @Prop({
    required: true,
    type: Object,
  })
  container!: object;

  @Watch('container')
  onContainer(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("container")
  }

  @Prop({
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  resource!: any;

  async $$load_resource() {
    return this.item || this.$fn.schemaDefaults('CreateComment', { object_id: this.parentId || this.parent.id })
  }

  editor!: any;

  async $$load_editor() {
    return this.resource.editor()
  }

  createTitle!: any;
  editTitle!: any;
  ux!: any;
  dataMembers = ['resource', 'editor', 'createTitle', 'editTitle', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        resource: null,
        editor: null,
        createTitle: this.$fn.pgettext("Comments", "Add comment"),
        editTitle: this.$fn.pgettext("Comments", "Edit comment"),
        ux: null,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.item == null == null ? this.createTitle : this.editTitle,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_2522_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_2522, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeComponent_2528_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_1040167445267876_closeComponent_2528, alias=undefined
    return {
      result: {
        value: $event.data.response.data,
      }
      ,
    }
  }

  async act_1040167445267876_closeComponent_2530_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_1040167445267876_closeComponent_2530, alias=undefined
    return {
      result: {
      }
      ,
    }
  }

  async act_1040167445267876_rest_2526_getActionArgs($event: actions.ActionEvent): Promise<actions.RestActionArgs> {
    // parameterResolver name=act_1040167445267876_rest_2526, alias=submit
    return {
      method: "save",
      container: this.container,
      resource: this.editor,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_2522: actions.CloseModalAction;
    evh_7315092382398562_close_2521: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_2524: actions.CloseComponentAction;
    evh_2248226175642056_close_2523: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeComponent_2528: actions.CloseComponentAction;
    evh_1040167445267876_saved_2527: actions.EventHandlerImpl;
    act_1040167445267876_closeComponent_2530: actions.CloseComponentAction;
    evh_1040167445267876_deleted_2529: actions.EventHandlerImpl;
    act_1040167445267876_rest_2526: actions.RestAction;
    evh_1040167445267876_submit_2525: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_2532: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_2531: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_2522 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_2522_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_2521 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_2522,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_2521],
      }
    );
    const act_2248226175642056_closeComponent_2524 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_2523 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_2524,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_2523],
      }
    );
    const act_1040167445267876_closeComponent_2528 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_1040167445267876_closeComponent_2528_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_saved_2527 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeComponent_2528,
        event: "saved",
        displayName: "closeComponent",
      }
    );
    const act_1040167445267876_closeComponent_2530 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_1040167445267876_closeComponent_2530_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_deleted_2529 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeComponent_2530,
        event: "deleted",
        displayName: "closeComponent",
      }
    );
    const act_1040167445267876_rest_2526 = new actions.RestAction(
      {
        actionArgs: this.act_1040167445267876_rest_2526_getActionArgs,
        displayName: "submit",
        events: [evh_1040167445267876_saved_2527, evh_1040167445267876_deleted_2529],
      }
    );
    const evh_1040167445267876_submit_2525 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_rest_2526,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_2525],
      }
    );
    const act_1419464017721962_closeComponent_2532 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_2531 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_2532,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_2531],
      }
    );
    return {
      act_7315092382398562_closeModal_2522,
      evh_7315092382398562_close_2521,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_2524,
      evh_2248226175642056_close_2523,
      evh_2248226175642056_close,
      act_1040167445267876_closeComponent_2528,
      evh_1040167445267876_saved_2527,
      act_1040167445267876_closeComponent_2530,
      evh_1040167445267876_deleted_2529,
      act_1040167445267876_rest_2526,
      evh_1040167445267876_submit_2525,
      evh_1040167445267876_submit,
      act_1419464017721962_closeComponent_2532,
      evh_1419464017721962_clickPreventStop_2531,
      evh_1419464017721962_clickPreventStop,
      submit: act_1040167445267876_rest_2526,
    }
  }
}

Vue.component("WComment", WComment);

</script>